import { render } from "./RequestDetailsModal.vue?vue&type=template&id=32094414&scoped=true"
import script from "./RequestDetailsModal.vue?vue&type=script&lang=js"
export * from "./RequestDetailsModal.vue?vue&type=script&lang=js"

import "./RequestDetailsModal.vue?vue&type=style&index=0&id=32094414&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32094414"]])

export default __exports__